import React from 'react';
import { get } from 'lodash/fp';
import StackedTxt from 'components/StackedText';
import ConfirmCancelCTA from 'components/ConfirmCancelOrders';
import TrackingLink from 'components/common/TrackingLink';
import { ORDER_STATES, BUYER_CONFIRMED, DELIVERED } from 'enums/order-state-enums';
import { OUT_OF_STOCK } from 'enums/table-enums';
import { priceFormatter } from 'utils/formatters';

/*
 * renders the data index of each column to the antd table
 */

export const renderImageCell = (link) => <img className="product-image" alt="product" src={link} />;

export const renderStackedText = (top, bottom) => <StackedTxt top={top} bottom={bottom} />;

export const renderPriceCell = (cents) => (
  <React.Fragment>
    <span className="price">{`$${priceFormatter(cents)}`}</span>
  </React.Fragment>
);

export const renderCTACell = (row) => <ConfirmCancelCTA order={row} label={row.shippingLabel} />;

export const renderTrackingLink = (row) => <TrackingLink row={row} />;

export const renderOrderStatus = (row) =>
  row.status === DELIVERED || row.status === BUYER_CONFIRMED ? (
    <span className="delivered">Delivered</span>
  ) : (
    get('displayName')(ORDER_STATES[row.status])
  );

export const renderStock = (quantity) =>
  quantity === 0 ? <div className="out-of-stock">{OUT_OF_STOCK}</div> : quantity;
